const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({
        startMoveOutDate: holder.startMoveOutDate,
        startMoveInDate: holder.startMoveInDate,
        endMoveOutDate: holder.endMoveOutDate,
        endMoveInDate: holder.endMoveInDate,
        selectedFloorplanIds: holder.selectedFloorplanIds,
        selectedTagIds: holder.selectedTagIds,
        noTagIds: holder.noTagIds,
      });
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closeFiltersDropdown);
    }
  }
};

export default {
  'MakeReadyFilters.Wrapper.HeaderWrapper': async ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds, containerRef, isOpen, noTagIds }, outlet, internalStateSetter) => {
    if (isOpen) {
      await internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closeFiltersDropdown);
      return;
    }

    await internalStateSetter('isOpen', !isOpen);

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.outlet = outlet;
    holder.startMoveOutDate = startMoveOutDate;
    holder.startMoveInDate = startMoveInDate;
    holder.endMoveOutDate = endMoveOutDate;
    holder.endMoveInDate = endMoveInDate;
    holder.selectedFloorplanIds = selectedFloorplanIds;
    holder.selectedTagIds = selectedTagIds;
    holder.noTagIds = noTagIds;

    document.addEventListener('mousedown', holder.closeFiltersDropdown);
  },
  'MakeReadyFilters.Wrapper.DropdownWrapper.BorderWrapper.MoveOutDate': ({ startDate, endDate }, _, internalStateSetter) => {
    holder.startMoveOutDate = startDate;
    holder.endMoveOutDate = endDate;

    internalStateSetter({ startMoveOutDate: startDate, endMoveOutDate: endDate })
  },
  'MakeReadyFilters.Wrapper.DropdownWrapper.BorderWrapper.MoveInDate': ({ startDate, endDate }, _, internalStateSetter) => {
    holder.startMoveInDate = startDate;
    holder.endMoveInDate = endDate;

    internalStateSetter({ startMoveInDate: startDate, endMoveInDate: endDate })
  },

  'MakeReadyFilters.Wrapper.DropdownWrapper.BorderWrapper.Floorplans': ({ selectedIds }, _, internalStateSetter) => {
    holder.selectedFloorplanIds = selectedIds;
    internalStateSetter({ selectedFloorplanIds: selectedIds });
  },
  'MakeReadyFilters.Wrapper.DropdownWrapper.BorderWrapper.Tags': ({ selectedIds, noTagIds }, _, internalStateSetter) => {
    holder.selectedTagIds = selectedIds;
    holder.noTagIds = noTagIds;
    internalStateSetter({ selectedTagIds: selectedIds, noTagIds: noTagIds, });
  },

  'MakeReadyFilters.Wrapper.DropdownWrapper.BorderWrapper.ResetFilters': ({ }, _, internalStateSetter) => {
    holder.selectedTagIds = [];
    holder.selectedFloorplanIds = [];
    holder.noTagIds = [];
    holder.startMoveInDate = null;
    holder.startMoveOutDate = null;
    holder.endMoveInDate = null;
    holder.endMoveOutDate = null;

    internalStateSetter({
      selectedTagIds: [],
      selectedFloorplanIds: [],
      startMoveInDate: null,
      startMoveOutDate: null,
      endMoveInDate: null,
      endMoveOutDate: null,
      noTagIds: []
    });
  }
};
